<template>
	<footer class="footer [ border-top ]">

		<div class="container [ text-center ]">

			<router-link to="/"><img src="../assets/logo-alt.svg" class="footer__logo" alt=""></router-link>

			<div class="footer__loghi [ mt-2 mb-4 ] [ row align-items-center justify-content-center ]">
				<div class="col-auto [ px-1 py-2 ]">
					<img src="../assets/logo-footer-1.png" class="img-fluid" alt="">
				</div>
				<div class="col-auto [ px-1 py-2 ]">
					<img src="../assets/logo-footer-2.png" class="img-fluid" alt="">
				</div>
				<div class="col-auto [ px-1 py-2 ]">
					<img src="../assets/logo-footer-3.png" class="img-fluid" alt="">
				</div>
				<div class="col-auto [ px-1 py-2 ]">
					<img src="../assets/logo-footer-4.png" class="img-fluid" alt="">
				</div>
				<div class="col-auto [ px-1 py-2 ]">
					<img src="../assets/logo-footer-5.png" class="img-fluid" alt="">
				</div>
				<div class="col-auto [ px-1 py-2 ]">
					<img src="../assets/logo-footer-6.png" class="img-fluid" alt="">
				</div>
				<div class="col-auto [ px-1 py-2 ]">
					<img src="../assets/logo-footer-7.png" class="img-fluid" alt="">
				</div>
			</div>

			<nav class="footer__menu [ is-limited-500 ]">
        <ul class="list-unstyled [ d-flex justify-content-center ]">
          <li>
            <router-link to="/" class="footer__link [ px-3 ]">Categorie</router-link>
          </li>
          <li>
            <router-link to="/eventi/all" class="footer__link [ px-3 ]">Calendario</router-link>
          </li>
          <li>
            <router-link to="/info" class="footer__link [ px-3 ]">Info</router-link>
          </li>
          <li>
            <router-link to="/richiesta-annullamento-prenotazione" class="footer__link [ px-3 ]">Annullamento prenotazione</router-link>
          </li>
        </ul>
			</nav>

			<p class="footer__text">
				Comune di Parma - Strada Repubblica 1, 43121 Parma<br>
				Partita IVA 00162210348
			</p>

		</div>

	</footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>
